<template>
  <section>
    <div class="container">
      <div class="list-cards-mobile">
        <div v-if="isMobile">
          <img class="img2" :src="path2.image" :alt="translateMain.assinar" width="288" height="522" loading="lazy" @click="redirectBanner(path2.url)"/>
        </div>
        <PostListItemMobile :posts="postBlogMobile" :home="true" />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { isMobile } from 'views/shared/utils/mobile'
import PostListItemMobile from './PostListItemMobile.vue'
import { defineComponent } from 'vue'
import { mapState } from 'pinia'
import { localeStore } from 'stores/locale'
import translateMain from 'tradutors/menu'

export default defineComponent({
  name: 'BlogMobile',
  components: { PostListItemMobile},
  props: ['postBlogs', 'path2'],
  computed: {
    ...mapState(localeStore, ['locale']),
    translateMain: function () {
      if (this.locale === 'pt-br') {
        return translateMain.portugues
      } else {
        return translateMain.ingles
      }
    }
  },
  data() {
    return {
      isMobile: isMobile(),
      postBlogMobile: [],
    }
  },
  watch: {
    'postBlogs': function () {
      this.postMobile()
    }
  },
  methods: {
    postMobile() {
      this.postBlogMobile = this.postBlogs.slice(3, 6)
    },
    redirectBanner(url){
        window.location.href = url;
    }
  }
})
</script>

<style scoped lang="css">

.list-cards-mobile {
  display: none;
}

.img2 {
  width: 288px;
  height: 522px;
  cursor: pointer;
}

@media screen and (max-width: 769px) {
  .list-cards-mobile {
    display: block;
  }
  .img2 {
    width: 100%;
    height: auto;
  }
}
</style>
